const theme = {
  colors: {
    accent: '#F59256',
    mainBackground: '#FDF7F2',
    secondaryBackground: '#ffffff',
    mainText: '#111111',
    searchText: '#535353',
    navText: '#181C27',
    newsText: '#111321',
    inputText: 'rgba(17, 17, 17, 0.6)',
    black: '#000000',
    link: '#3091EB',
    inputOutline: 'rgba(245, 146, 86, 0.5)',
    background: '#e1e1e1',
  },
  border: {
    main: '2px solid #F59256',
    auth: '1px solid rgba(245, 146, 86, 0.5)',
    inputOutline: '1px solid',
  },
  borderRadius: {
    br40: '40px',
    br20: '20px',
  },
  fontsFamily: {
    main: 'Manrope',
    secondary: 'Inter',
    logo: 'Poppins',
  },
  fontSize: {
    fs12: '12px',
    fs14: '14px',
    fs16: '16px',
    fs18: '18px',
    fs20: '20px',
    fs24: '24px',
    fs28: '28px',
    fs32: '32px',
    fs48: '48px',
    fs68: '68px',
  },
  fontWeight: {
    fw400: '400',
    fw500: '500',
    fw600: '600',
    fw700: '700',
  },

  transition: { first: '250ms cubic-bezier(0.57, 0.21, 0.69, 1.25)' },
};

export default theme;
